<template>
  <div class="calendar-legend">

    <div class="col">
      <p class=""><span class="free-dates legend">14</span>{{$t('free-dates')}}</p>
      <p class=""><span class="holiday-dates legend"><span>14</span> <span class="holiday-name">
            {{ $t('holiday') }}</span></span>{{$t('holiday-dates')}}</p>
      <p class=""><span class="weekend-dates legend">14</span>{{$t('weekend-dates')}}</p>
    </div>
    <div class="col">
      <p class=""><span class="start-dates legend">14</span>{{$t('start-dates')}}</p>
      <p class=""><span class="end-dates legend">14</span>{{$t('end-dates')}}</p>
      <p class=""><span class="occupied-dates legend">14</span>{{$t('occupied-dates')}}</p>
    </div>

    <div class="col">
      <p class=""><span class="possible_to_book legend">14</span>{{$t('possible_to_book')}}</p>
      <p class=""><span class="not_bookable-dates legend">14</span>{{$t('not_bookable-dates')}}</p>
    </div>

  </div>
</template>

<script setup lang="ts">

</script>
